export default __webpack_public_path__ + "static/app-gallery-cf5a7ba1dadae17486bec3f87787b09c.png";